/**
 * keyboardShortcuts.ts
 * キーボードショートカット処理
 * App.vue から切り出し
 */

import {
  drawCancel,
  drawConfirm,
  removeLastVertex,
  drawUndo,
  drawRedo,
} from '@/js/draw'

type VM = any

export function onKeydown(vm: VM, e: KeyboardEvent) {
  // テキスト入力中は無効化
  const target = e.target as HTMLElement
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return;
  }

  // ドローモードがオフの時は描画ショートカットを無効化
  const isDrawModeActive = vm.s_isDraw;

  // ショートカット一覧表示 (?)
  if (isDrawModeActive && e.key === '?' && !e.ctrlKey && !e.metaKey) {
    e.preventDefault();
    vm.$store.commit('setFloatingVisible', { id: 'draw-help-window', visible: true });
    return;
  }

  // 描画モード切り替えショートカット（ドローモードがオンの時のみ）
  if (isDrawModeActive && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey) {
    switch(e.key.toLowerCase()) {
      case 'p':
        e.preventDefault();
        vm.toggleDrawPoint();
        break;
      case 'l':
        e.preventDefault();
        vm.toggleLDrawLine();
        break;
      case 'o':
        e.preventDefault();
        vm.toggleLDrawPolygon();
        break;
      case 'c':
        e.preventDefault();
        vm.toggleDrawCircle();
        break;
      case 'f':
        e.preventDefault();
        vm.toggleLDrawFree();
        break;
      case 's':
        e.preventDefault();
        vm.toggleDrawLasso();
        break;
      case 'e':
        e.preventDefault();
        vm.toggleEditEnabled();
        break;
      case 't':
        e.preventDefault();
        vm.toggleDrawText();
        break;
    }
  }

  // Undo/Redo (Ctrl+Z / Ctrl+Shift+Z)
  if (isDrawModeActive && (e.ctrlKey || e.metaKey)) {
    if (e.shiftKey && e.key.toLowerCase() === 'z') {
      e.preventDefault();
      drawRedo();
      return;
    }
    if (!e.shiftKey && e.key.toLowerCase() === 'z') {
      e.preventDefault();
      drawUndo();
      return;
    }
  }

  // ESC - スワイプモード解除、複製モード解除、描画モード解除、または現在の描画キャンセル
  if (e.key === 'Escape') {
    // 複製モードの場合はキャンセル
    if (vm.$store.state.isDrawDuplicate) {
      e.preventDefault();
      vm.$store.commit('setDrawDuplicate', false)
      vm.$store.commit('setDuplicateSourceFeature', null)
      return;
    }
    // スワイプモードの場合は終了して1画面に戻る
    if (vm.swipeMode) {
      e.preventDefault();
      vm.exitSwipeAndSplit();
      return;
    }
    if (isDrawModeActive) {
      e.preventDefault();
      if (vm.s_isDrawLine || vm.s_isDrawPolygon || vm.s_isDrawFree) {
        // 描画中ならキャンセル
        drawCancel();
      } else if (vm.s_editEnabled) {
        // 編集モードならオフ
        vm.toggleEditEnabled();
      } else {
        // それ以外はドローモード自体をオフ
        vm.toggleLDraw();
      }
    }
    return;
  }

  // Enter - ライン/ポリゴン描画の確定
  if (e.key === 'Enter') {
    if (vm.s_isDrawLine || vm.s_isDrawPolygon) {
      e.preventDefault();
      drawConfirm();
    }
    return;
  }

  // Backspace/Delete - 頂点削除
  if (vm.s_isDrawLine || vm.s_isDrawPolygon) {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      e.preventDefault();
      removeLastVertex();
    }
  }
}
